import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgNudgeHourglass = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 3A.75.75 0 0 1 4 2.25h12a.75.75 0 0 1 0 1.5h-.393v.37c0 2.324-.955 3.967-1.909 5.019-.318.35-.636.636-.919.861.283.225.601.51.92.861.953 1.052 1.908 2.694 1.908 5.019v.37H16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h.393v-.37c0-2.325.955-3.967 1.909-5.019.318-.35.636-.636.919-.861a7.777 7.777 0 0 1-.92-.861C5.349 8.087 4.394 6.444 4.394 4.12v-.37H4A.75.75 0 0 1 3.25 3Zm2.643.75v.37c0 1.876.76 3.173 1.52 4.011.383.422.766.727 1.05.925a4.845 4.845 0 0 0 .44.27v.002a.75.75 0 0 1 0 1.344v.001a19.202 19.202 0 0 0-.104.057 4.843 4.843 0 0 0-.336.214 6.227 6.227 0 0 0-1.05.925c-.76.838-1.52 2.136-1.52 4.011v.37h8.214v-.37c0-1.876-.76-3.173-1.52-4.011a6.227 6.227 0 0 0-1.05-.925 4.835 4.835 0 0 0-.434-.268l-.005-.003h-.002a.75.75 0 0 1 0-1.345l.002-.001a1.198 1.198 0 0 0 .103-.057c.077-.045.194-.116.336-.214a6.23 6.23 0 0 0 1.05-.925c.76-.838 1.52-2.135 1.52-4.011v-.37H5.893Zm5.204 6.923Zm-2.194 0h-.001Z"
    />
  </svg>
);
export default SvgNudgeHourglass;
